<div class="body-container">
  <div class="page-container">
    <div class="form-wrapper">
      <div class="form-content">
        <!-- Automatic Payments  -->
        <div class="form-section  form-dunning">
          <div class="form-section-side">
            <h1 class="label-title">Dunning for Automatic Payments</h1>
            <nav class="nav-links edit-link">
              <a [routerLink]="['../automatic-payments-config']" routerLinkActive="router-link-active" class="custom-mat-link link-option">Edit</a>
            </nav>
          </div>
          <div class="form-section-container padding nopadding">
            <div class="form-section-inner">
              <div class="form-section-head header">
              </div>
              <div class="form-section-body">
                <mat-card class="custom-mat-card card-form-wrapper size size1of1">
                  <mat-card-content class="card-content">
                    <div class="card-section padding nopadding">

                      <mat-list *ngIf="isDunningClycleAutoReady" [@skeletonListAnimation] class="custom-mat-list list-grid-std list-company-currency">
                        <mat-list-item *ngIf="dunningClycleAuto.length === 0"
                          class="custom-mat-list-item grid-row">
                          <h3 matLine class="typo body-1 semi-condensed fw600 label-title">
                            There is no configuration for automatic payments
                          </h3>
                        </mat-list-item>
                        <mat-list-item *ngFor="let cycle of dunningClycleAuto let i = index" class="custom-mat-list-item grid-row">
                          <h3 matLine class="typo body-1 semi-condensed fw600 label-title">Retry Cycle #{{ i + 1 }}</h3>
                          <p matLine *ngIf="i === 0" class="typo note regular fw400 label-subtitle">Payment Decline Dunning will retry collect invoices {{cycle.cycleFrec}} day(s) after the initial payment attempt fails.</p>
                          <p matLine *ngIf="i > 0" class="typo note regular fw400 label-subtitle">Payment Decline Dunning will retry collect invoices {{cycle.cycleFrec}} day(s) after Retry Cycle #{{i}}.</p>
                        </mat-list-item>
                        <mat-list-item *ngIf="dunningCycleActionAuto" class="custom-mat-list-item grid-row">
                          <h3 *ngIf="dunningCycleActionAuto === 'stop_cancel'" matLine class="typo body-1 semi-condensed fw600 label-title">
                            {{collectionOfDunningCycleAutoCounters[collectionOfDunningCycleAutoCounters.length-1]}} day after Payment Decline Dunning had finished, the rate plan will expire.
                          </h3>
                          <h3 *ngIf="dunningCycleActionAuto === 'stop'" matLine class="typo body-1 semi-condensed fw600 label-title">
                            {{collectionOfDunningCycleAutoCounters[collectionOfDunningCycleAutoCounters.length-1]}} day after the Payment Decline Dunning had finished, the rate plan will continue active.
                          </h3>
                          <h3 *ngIf="dunningCycleActionAuto === 'retry'" matLine class="typo body-1 semi-condensed fw600 label-title">
                            {{collectionOfDunningCycleAutoCounters[collectionOfDunningCycleAutoCounters.length-1]}} day after the Payment Decline Dunning had finished cycles will reset and the Payment Decline Dunning will start over.
                          </h3>
                        </mat-list-item>
                      </mat-list>

                      <mat-list  *ngIf="!isDunningClycleAutoReady" [@skeletonListAnimation] class="custom-mat-list list-grid-std list-skeleton">
                        <mat-list-item class="custom-mat-list-item grid-row">
                          <h3 matLine ><skeleton-loader
                            [theme]="{'width': '20%'}"></skeleton-loader></h3>
                          <p matLine ><skeleton-loader
                            [theme]="{'width': '40%'}"></skeleton-loader></p>
                        </mat-list-item>
                      </mat-list>

                    </div>
                  </mat-card-content>
                </mat-card>
              </div>
            </div>
          </div>
        </div>
        <!-- Dunning for Manual Payments  -->
        <!--
        <div class="form-section form-dunning">
          <div class="form-section-side">
            <h1 class="label-title">Dunning for Manual Payments</h1>
            <nav class="nav-links edit-link">
              <a [routerLink]="['../manual-payments-config']" routerLinkActive="router-link-active"
                class="custom-mat-link link-option">Edit</a>
            </nav>
          </div>
          <div class="form-section-container padding nopadding">
            <div class="form-section-inner">
              <div class="form-section-body">
                <mat-card class="custom-mat-card card-form-wrapper size size1of1">
                  <mat-card-content class="card-content">
                    <div class="card-section padding nopadding">

                      <mat-list  *ngIf="isDunningClycleManualReady" [@skeletonListAnimation] class="custom-mat-list list-grid-std list-company-currency">
                        <mat-list-item *ngIf="dunningClycleManual.length === 0"
                          class="custom-mat-list-item grid-row">
                          <h3 matLine class="typo body-1 semi-condensed fw600 label-title">
                            There is no configuration for manual payments
                          </h3>
                        </mat-list-item>
                        <mat-list-item *ngFor="let cycle of dunningClycleManual let i = index"
                          class="custom-mat-list-item grid-row">
                          <h3 matLine class="typo body-1 semi-condensed fw600 label-title">
                            Day {{collectionOfDunningCycleManualCounters[i]}} - #{{ i + 1 }} Email
                          </h3>
                          <p *ngIf="i === 0" matLine class="typo note regular fw400 label-subtitle">Sent to the customer {{cycle.cycleFrec}} day after the initial payment attempt fails.
                          </p>
                          <p *ngIf="i > 0" matLine class="typo note regular fw400 label-subtitle">Sent to the customer {{cycle.cycleFrec}} day after the previous email is sent.
                          </p>
                        </mat-list-item>
                        <mat-list-item *ngIf="dunningCycleActionManual" class="custom-mat-list-item grid-row">
                          <h3 *ngIf="dunningCycleActionManual === 'stop_cancel'" matLine class="typo body-1 semi-condensed fw600 label-title">
                            {{collectionOfDunningCycleManualCounters[collectionOfDunningCycleManualCounters.length-1]}} day after the subscription will expire.
                          </h3>
                          <h3 *ngIf="dunningCycleActionManual === 'stop'" matLine class="typo body-1 semi-condensed fw600 label-title">
                            {{collectionOfDunningCycleManualCounters[collectionOfDunningCycleManualCounters.length-1]}} day after the subscription will continue active and the emails will stop.
                          </h3>
                          <h3 *ngIf="dunningCycleActionManual === 'retry'" matLine class="typo body-1 semi-condensed fw600 label-title">
                            {{collectionOfDunningCycleManualCounters[collectionOfDunningCycleManualCounters.length-1]}} day after the emails will continue until payment is done.
                          </h3>
                        </mat-list-item>
                      </mat-list>

                      <mat-list *ngIf="!isDunningClycleManualReady" [@skeletonListAnimation] class="custom-mat-list list-grid-std list-skeleton">
                        <mat-list-item class="custom-mat-list-item grid-row">
                          <h3 matLine ><skeleton-loader
                            [theme]="{'width': '20%'}"></skeleton-loader></h3>
                          <p matLine ><skeleton-loader
                            [theme]="{'width': '40%'}"></skeleton-loader></p>
                        </mat-list-item>
                      </mat-list>

                    </div>
                  </mat-card-content>
                </mat-card>
              </div>
            </div>
          </div>
        </div>
      -->
      </div>
    </div>
  </div>
</div>
